import { render } from "./NavLogoIcon.vue?vue&type=template&id=44aa75b9"
import script from "./NavLogoIcon.vue?vue&type=script&lang=js"
export * from "./NavLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__